<template>
  <div style="width:100%;">
    <!-- <CCol col="12" xl="12"> -->
    <!-- <CCard>
      <CCardHeader>Daily Information</CCardHeader>
      <CCardBody v-if="data"> -->
      <div style="width:100%;float:left;" v-if="data && dashShow && budget && !loading">
        <CCard>
          <CCardBody>
            <div style="width:100%;float:left;text-align:center;">
              <input type="date" class="form-control ml-auto mr-auto" style="width:250px;" @change="getData()" v-model="date" />
            </div>
          </CCardBody>
        </CCard>
        <CCard v-if="notes && notes.length">
          <CCardHeader style="cursor: pointer;" @click="notesCollapsed = !notesCollapsed">
            Notes (there might be a note that needs your attention, click to open)
            <div class="card-header-actions">
              <CLink class="card-header-action btn-minimize">
                <CIcon :name="`cil-chevron-${notesCollapsed ? 'bottom' : 'top'}`"/>
              </CLink>
            </div>
          </CCardHeader>
          <CCollapse :show="notesCollapsed" :duration="400">
            <CCardBody>
              <div style="width:100%;float:left;text-align:center;padding-bottom:15px;">
                <div v-for="val in notes" class="message">
                  {{val.text}}
                </div>
              </div>
            </CCardBody>
          </CCollapse>
        </CCard>
        <h3 style="width:100%;float:left;text-align:center;">Daily Information</h3>
        <div class="col-sm-6 col-md-6 float-left" v-for="(val, key) in data">
          <div class="card" style="cursor: pointer;">
            <div
              class="card-header content-center text-white p-0"
              style="background-color: #81b440;"
            >
              {{key}}
            </div>
            <div class="card-body row text-center" @click="showData(val, 'daily_information')">
              <div class="col">
                <div class="text-value-lg">
                  ${{computeTotal(val, 'daily_shipped')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Shipped
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeTotal(val, 'daily_booked')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Ordered
                </div>
              </div>
            </div>
            <div class="card-body row text-center" @click="showData(val, 'daily_information')">
              <div class="col">
                <div class="text-value-lg">
                  {{computeTotal(val, 'shipped_units')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Shipped Units
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  {{computeTotal(val, 'booked_units')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Booked Units
                </div>
              </div>
            </div>
            <div class="card-body row text-center" @click="showData(key, 'monthly')">
              <div class="col">
                <div class="text-value-lg">
                  ${{computeMonthTotal(key, 'daily_shipped')}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Shipped
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeMonthTotal(key, 'daily_booked')}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Ordered
                </div>
              </div>
            </div>
            <div class="card-body row text-center" @click="showData(key, 'monthly')">
              <div class="col">
                <div class="text-value-lg">
                  {{computeMonthTotal(key, 'shipped_units')}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Shipped Units
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  {{computeMonthTotal(key, 'booked_units')}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Booked Units
                </div>
              </div>
            </div>
            <div class="card-body row text-center">
              <div class="col">
                <div class="text-value-lg">
                  ${{getMonthlyBudget(key)}}
                </div>
                <div class="text-uppercase text-muted small">
                  Budget
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  {{computeMonthlyBudget(key)}}%
                </div>
                <div class="text-uppercase text-muted small">
                  % of Budget Shipped
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width:100%;float:left;" v-if="data && dashShow && !loading">
        <div class="col-sm-12 col-md-12 float-left">
          <div class="card" style="cursor: pointer;">
            <div
              class="card-header content-center text-white p-0"
              style="background-color: #81b440;"
            >
              Totals
            </div>
            <div class="card-body row text-center">
              <div class="col">
                <div class="text-value-lg">
                  ${{computeCompleteTotal('daily_shipped')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Shipped
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{parseInt(computeCompleteMonthTotal('daily_shipped')).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Shipped
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeCompleteTotal('daily_booked')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Daily Booked
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{parseInt(computeCompleteMonthTotal('daily_booked')).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </div>
                <div class="text-uppercase text-muted small">
                  MTD Booked
                </div>
              </div>
            </div>
            <div class="card-body row text-center">
              <div class="col">
                <div class="text-value-lg">
                  ${{parseInt(computeTotalBudget()).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")}}
                </div>
                <div class="text-uppercase text-muted small">
                  Total Budget
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  {{parseFloat(computePercentBudget()).toFixed(2)}}
                </div>
                <div class="text-uppercase text-muted small">
                  % Budget
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width:100%;float:left;" v-if="data && dashShow && !loading">
        <h3 style="width:100%;float:left;text-align:center;">Orders in the System</h3>
        <div class="col-sm-12 col-md-12 float-left" v-for="(val, key) in data">
          <div class="card" style="cursor: pointer;" @click="showData(val, 'orders_in_system')">
            <div
              class="card-header content-center text-white p-0"
              style="background-color: #81b440;"
            >
              {{key}}
            </div>
            <div class="card-body row text-center">
              <div class="col">
                <div class="text-value-lg">
                  ${{computeTotal(val, 'late_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Current & Late
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeTotal(val, 'balance_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Future Ship Dates
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeTotal(val, 'total_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Total
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div style="width:100%;float:left;" v-if="data && dashShow && !loading">
        <div class="col-sm-12 col-md-12 float-left">
          <div class="card" style="cursor: pointer;">
            <div
              class="card-header content-center text-white p-0"
              style="background-color: #81b440;"
            >
              Totals
            </div>
            <div class="card-body row text-center">
              <div class="col">
                <div class="text-value-lg">
                  ${{computeOrdersTotal('late_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Current & Late
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeOrdersTotal('balance_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Future Ship Dates
                </div>
              </div>
              <div class="c-vr"></div>
              <div class="col">
                <div class="text-value-lg">
                  ${{computeOrdersTotal('total_open')}}
                </div>
                <div class="text-uppercase text-muted small">
                  Total Open
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <small-loader v-if="loading"></small-loader>

      <div style="width:100%;float:left;" v-if="!dashShow && reportData">
        <sales-table :reportData="reportData" @back="dashShow = true, reportData = null" :reportType="reportType" :date="date"></sales-table>
      </div>
      <!-- </CCardBody>  
    </CCard> -->
    <!-- </CCol> -->
  </div>
</template>

<script>
import SalesTable from './sales_table'
var moment = require('moment');
var methods = {}

methods.getData = function () {
  console.log('getting')
  this.loading = true
  const postData = {
    date: this.date
  }
  console.log(window.localStorage.getItem('api_token'))
  axios.post(this.$apiAdress + '/api/getSalesDashboard?token=' + window.localStorage.getItem('api_token'), postData).then(response => {
    console.log(response)
    var obj = {}
    var monthObj = {}
    var yesterday = moment()
    this.notes = response.data.notes
    yesterday.subtract(1, 'd')
    yesterday = yesterday.format('YYYY-MM-DD')
    console.log(yesterday)
    response.data.daily_sales.forEach(function (val) {
      if (val.area !== '') {
        // if (val.date === yesterday) {
          if (!obj[val.area]) {
            obj[val.area] = []
          }
          obj[val.area].push(val)
          if (!monthObj[val.area]) {
            monthObj[val.area] = []
          }
          monthObj[val.area].push(val)
        // } else {
        //   if (!monthObj[val.area]) {
        //     monthObj[val.area] = []
        //   }
        //   monthObj[val.area].push(val)
        // }
      }
    })
    console.log(obj)
    this.data = obj
    this.monthData = response.data.monthly_totals
    this.getBudget()
  }).catch(e => {
    console.log('error');
    console.log(e)
  })
}

methods.computeTotalBudget = function () {
  var total = 0
  for (var key in this.data) {
    if (this.budget[key]) {
      total += parseFloat(this.budget[key][this.budgetMonth])
    }
  }
  return total
}

methods.computePercentBudget = function () {
  var budget = parseFloat(this.computeTotalBudget())
  var total = parseFloat(this.computeCompleteMonthTotal('daily_shipped'))
  var calc = parseFloat(total / budget) * 100
  return calc
}

methods.computeOrdersTotal = function (type) {
  var total = 0
  for (var key in this.data) {
    total += parseFloat(this.computeTotal(this.data[key], type).replace(/,/g, ''))
  }
  total = parseInt(total.toFixed(2))
  return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeCompleteTotal = function (type) {
  var total = 0
  console.log('compute total')
  console.log(this.data)
  if (this.data) {
    for (var key in this.data) {
      console.log(key)
      console.log('keyyyyyy')
      console.log(this.data[key])
      this.data[key].forEach(function (val) {
        total += parseFloat(val[type] || 0)
      })
    }
  }
  total = parseInt(total.toFixed(2))
  return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeCompleteMonthTotal = function (type) {
  var total = 0
  if (this.monthData) {
    for(var key in this.monthData) {
      console.log(key)
      console.log(this.monthData[key])
      // this.monthData[key].forEach(function (val) {
        total += parseFloat(this.monthData[key][type] || 0)
      // })
    }
  }
  total = parseInt(total.toFixed(2))
  return total
}

methods.getBudget = function () {
  const postData = {
    date: this.date
  }
  axios.post(this.$apiAdress + '/api/getBudget?token=' + window.localStorage.getItem('api_token'), postData)
  .then(response => {
    console.log(response)
    var obj = {}
    response.data.res.forEach(function (val) {
      if (!obj[val.area]) {
        obj[val.area] = []
      }
      obj[val.area] = val
    })
    this.budget = obj
    this.budgetMonth = response.data.month
    console.log('budget')
    console.log(this.budget)
    this.loading = false
  })
}

methods.showData = function (val, type) {
  this.reportData = val
  this.reportType = type
  var that = this
  setTimeout(function () {
    that.dashShow = false
  }, 500)
}

methods.computeMonthlyBudget = function (key) {
  if (this.budget[key]) {
    var total = this.budget[key][this.budgetMonth]

    var value = 0
    value = parseFloat(this.monthData[key].daily_shipped)
    value = value.toFixed(2)
    console.log('monthly total')
    console.log(value)
    var calc = parseFloat(parseFloat(value) / parseFloat(total)).toFixed(2)
    calc = parseFloat(calc) * 100
    calc = parseInt(parseFloat(calc).toFixed(2))
    return calc.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
}

methods.getMonthlyBudget = function (key) {
  console.log(key)
  console.log(this.budget)
  if (this.budget[key]) {
    var total = this.budget[key][this.budgetMonth]
    return total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
}

methods.computeTotal = function (val, type) {
  var total = 0
  val.forEach(function (item) {
      total += parseFloat(item[type] || 0)
  })
  if (type !== 'shipped_units' && type !== 'booked_units') {
    total = parseInt(total.toFixed(2))
  }
  return parseInt(total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
}

methods.computeMonthTotal = function (key, type) {
  var total = 0
  // this.monthData[key].forEach(function (item) {
  //   total += parseFloat(item[type])
  // })
  console.log(key)
  console.log(type)
  console.log(this.monthData)
  if (this.monthData[key]) {
    total = parseInt(this.monthData[key][type])
    if (type !== 'shipped_units' && type !== 'booked_units') {
      total = total.toFixed(2)
    }
    return parseInt(total).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  } else {
    return 0
  }
}

export default {
  name: 'SalesDashboard',
  data: () => {
    return {
      data: null,
      budget: null,
      monthData: null,
      dashShow: true,
      reportData: null,
      loading: true,
      budgetMonth: '',
      date: '',
      notes: null,
      notesCollapsed: false,
    }
  },
  computed: {
  },
  components: {
    SalesTable
  },
  methods: methods,
  mounted: function(){
    this.date = moment().subtract(1, 'days').format('YYYY-MM-DD')
    this.getData();
    // this.getBudget();
  }
}
</script>

<style scoped>
.card-body >>> table > tbody > tr > td {
  cursor: pointer;
}
.message {
  width: 100%;
  height: auto;
  padding:2px 5px;
  text-align: left;
  border-radius:5px;
  float:left;
  background-color: #8ac0ff;
  margin-top: 10px;
}
</style>
